import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js';
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';
import { Vector2 } from 'three';
import { statsBegin, statsEnd } from 'Domain/Scene/Utils/StatsManager';



let selectedTeeth = [];

const cameraComposers = new Map();

const createOutlinePass = (scene, camera, color) => {
    const outlinePass = new OutlinePass(new Vector2(window.innerWidth, window.innerHeight), scene, camera);
    outlinePass.edgeStrength = 4.0;
    outlinePass.edgeGlow = 0.5;
    outlinePass.edgeThickness = 1;
    outlinePass.visibleEdgeColor.set(color);
    return outlinePass;
};



export const buildComposer = (renderer, scene) => {


    const cameraNames = {
        MainCamera: 'main',
        FrontCamera: 'front',
        BottomCamera: 'bottom',
        TopCamera: 'top',
        ComparativeCamera: 'comparative'
    };

    Object.entries(cameraNames).forEach(([camName, camKey]) => {
        const color = 0x00ffff;
        const camera = threeEngine.getCamera(camKey); // Utilisation de la bonne clé

        if (!camera) {
            console.error(`buildComposer: Camera ${camKey} not found.`);
            return;
        }

        const composer = new EffectComposer(renderer);
        const renderPass = new RenderPass(scene, camera);
        const outlinePass = createOutlinePass(scene, camera, color);

        composer.addPass(renderPass);
        composer.addPass(outlinePass);
        cameraComposers.set(camName, { composer, outlinePass });
    });


}

export const composerRender = (scene, camera, innerWidth, innerHeight) => {
    const entry = cameraComposers.get(camera.name);
    if (!entry) return;

    const { composer, outlinePass } = entry;
    composer.setSize(innerWidth, innerHeight);
    outlinePass.camera = camera;
    outlinePass.scene = scene;
    outlinePass.resolution.set(innerWidth, innerHeight);

    outlinePass.selectedObjects = selectedTeeth;
    statsBegin()
    composer.render();
    statsEnd()
}

export const buildTeethOutline = async (mesh) => {
    selectedTeeth = [mesh];
    cameraComposers.forEach(({ outlinePass }) => {
        outlinePass.selectedObjects = selectedTeeth;
    });
};

export const destroyTeethOutline = () => {
    selectedTeeth = [];
    cameraComposers.forEach(({ outlinePass }) => {
        outlinePass.selectedObjects = selectedTeeth;
    });
};

export const disposeComposers = () => {
    cameraComposers.forEach(({ composer, outlinePass }) => {
        if (outlinePass) {
            outlinePass.selectedObjects = [];
            outlinePass.dispose();
        }
        if (composer) {
            composer.dispose();
        }
    });
    cameraComposers.clear();
    selectedTeeth = [];
};
